/* eslint-disable max-len */
import React, { useEffect, useRef } from "react"
import { useHMSActions } from "@100mslive/react-sdk"
import { useInView } from "react-intersection-observer"
import { formatDateTo12HourTime } from 'utils/timeFormatters'
import { Box } from "../shared/box"
import Flex from "../shared/flex"
import { Text } from "../shared/text"
import { CircleDivider, Link, SenderName, TextMessage } from "./styles"

const URL_REGEX =
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/

export const AnnotisedMessage = ({ message }) => {
  if (!message) {
    return null
  }

  return (
    <>
      {message
        .trim()
        .split(/(\s)/)
        .map((part) =>
          URL_REGEX.test(part) ? (
            <Link href={part} key={part} target="_blank" rel="noopener noreferrer">
              {part}
            </Link>
          ) : (
            part
          ),
        )}
    </>
  )
}

const ChatMessage = ({ message }) => {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true })
  const rowRef = useRef(null)
  const hmsActions = useHMSActions()

  useEffect(() => {
    if (message.id && !message.read && inView) {
      hmsActions.setMessageRead(true, message.id)
    }
  }, [message.read, hmsActions, inView, message.id])

  if (message.message?.includes("PROMO:")) {
    return null
  }

  const cleanedName = message.senderName.replace(/[^a-zA-Z0-9\s]/g, "")

  return (
    <Box ref={ref} as="div" css={{ overflow: "hidden" }}>
      <Flex
        gap=".3"
        ref={rowRef}
        align="center"
        css={{
          flexWrap: "wrap",
          background: undefined,
          paddingRight: "0.5rem",
          paddingLeft: "0.5rem",
          paddingTop: 0,
          paddingBottom: 0,
          userSelect: "none",
        }}
        key={message.time}
        data-testid="chat_msg"
      >
        <Flex
          gap="0"
          css={{
            color: "rgba(0,0,0, 0.82)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            fontSize: "1.6rem",
            height: "2rem",
          }}
          as="div"
        >
          <Flex align="center" gap="0">
            {!cleanedName ? (
              <SenderName>{cleanedName || "Anonymous"}</SenderName>
            ) : (
              <SenderName>{cleanedName}</SenderName>
            )}
            <CircleDivider />
            <Text
              css={{
                color: "rgba(0,0,0, 0.72)",
                flexShrink: 0,
                margin: 0,
                marginLeft: "0.6rem",
                fontSize: "1.2rem",
              }}
            >
              {formatDateTo12HourTime(message.time)}
            </Text>
          </Flex>
        </Flex>
        <TextMessage onClick={(e) => e.stopPropagation()}>
          <AnnotisedMessage message={message.message} />
        </TextMessage>
      </Flex>
    </Box>
  )
}

export default ChatMessage
